import { render, staticRenderFns } from "./ConfigLogo.vue?vue&type=template&id=ba869ad2&scoped=true&"
import script from "./ConfigLogo.vue?vue&type=script&lang=js&"
export * from "./ConfigLogo.vue?vue&type=script&lang=js&"
import style0 from "./ConfigLogo.vue?vue&type=style&index=0&id=ba869ad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba869ad2",
  null
  
)

export default component.exports